import React from 'react';
import PropTypes from 'prop-types';
import ReactMapboxGl, {Marker} from 'react-mapbox-gl';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons';
import ResourceComponent from '../../../common/ResourceComponent';

const Map = ReactMapboxGl({
    accessToken: 'pk.eyJ1IjoiZGFyZWstZ2Rzb2Z0IiwiYSI6ImNsZzI1azZiYTAyYmczZ2xvMThvODVqeGMifQ.cB1bWxkvcwxuc4rR0o22LQ',
});

class SourceTreeMap extends ResourceComponent {

    state = {
        mapDefaults: {
            zoom: [17],
            center: [this.defaultMapCenter.long, this.defaultMapCenter.lat],
        },
        ready: false,

    };

    componentDidMount() {
        const {tree} = this.props;
        if (this.props.tree) {
            const center = [tree.long, tree.lat];
            this.setState({mapDefaults: {...this.state.mapDefaults, center: center}, ready: true});
        }
    }

    render() {
        const {tree, style} = this.props;
        const {mapDefaults, ready} = this.state;
        return (
            ready &&
            <Map
                {...mapDefaults}
                className='modal-map'
                style={style ? style : 'mapbox://styles/mapbox/satellite-streets-v10'}
            >
                <Marker
                    style={{color: tree.color ? tree.color : '#f2ff25', width: 25, height: 25}}
                    coordinates={[tree.long, tree.lat]}
                >
                    <FontAwesomeIcon
                        icon={faMapMarkerAlt}
                    />
                </Marker>
            </Map>
        );
    }
}

SourceTreeMap.propTypes = {
    style: PropTypes.string,
    tree: PropTypes.object,
};

export default SourceTreeMap;


// WEBPACK FOOTER //
// ./src/containers/embeddable/utils/SourceTreeMap.js